import { isAuth, recoverPassword } from "../actions/usersActions.js";
import { useDispatch } from "react-redux";
import { generateToken } from "../actions/manageSessionsAction";
import { useAppSelector } from "./useAppHooks.js";
import {
  closeLoading,
  openLoading,
} from "../components/loadingModal/loading.js";

const useLogin = () => {
  const dispatch = useDispatch();
  const loggedUser = useAppSelector((state) => state.usersReducer.userLogged);
  const sessionExpired = localStorage.getItem("sessionExpired");

  const confirmIsAuth = async () => {
    try {
      await dispatch(isAuth());
    } catch (err) {
      throw err;
    }
  };

  const resetPassword = async (email) => {
    try {
      const response = await dispatch(recoverPassword(email));
      return response;
    } catch (err) {
      throw err;
    }
  };

  const refreshToken = async (token) => {
    try {
      await dispatch(generateToken(token));
    } catch (err) {
      throw err;
    }
  };

  return {
    sessionExpired,
    loggedUser,
    confirmIsAuth,
    resetPassword,
    refreshToken,
  };
};

export default useLogin;
